import {objectToCamelCase, objectToSnakeCase} from '../utils'

import Organization from '@/services/organizations'
import AdminPermissions from '@/services/adminPermissions'
import api from './api'

export default class Admin {
  static api = api.create(Admin)
  static readOnlyFields = ['id']

  constructor(admin) {
    const {
      id = '',
      firstName = '',
      lastName = '',
      email = '',
      fullName = '',
      organizationRef = null,
      isStaff = null,
      isAdmin = null,
      isEmployee = null,
      pendingMagicTokenInvite = null,
      adminPermissions = null,
      isPartOfPooledOrganization = null,
      subOrganizationRef = {},
      isSubOrgAdmin,
      preferredLanguage = 'en',
    } = admin
    Object.assign(this, {
      id,
      firstName,
      lastName,
      email,
      fullName,
      organizationRef: organizationRef ? Organization.fromAPI(organizationRef) : null,
      isStaff,
      isAdmin,
      isEmployee,
      pendingMagicTokenInvite,
      isPartOfPooledOrganization,
      adminPermissions: adminPermissions ? AdminPermissions.fromAPI(adminPermissions) : null,
      isSubOrgAdmin: isSubOrgAdmin,
      preferredLanguage: 'en',
      subOrganization: subOrganizationRef
        ? {id: subOrganizationRef['id'], name: subOrganizationRef['name']}
        : null,
      preferredLanguage,
    })
  }

  static create(opts) {
    return new Admin(opts)
  }

  static fromAPI(json = {}) {
    return new Admin(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The `User.readOnlyFields` are always excluded.
   **/
  static toAPI(admin, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = admin[field]
      })
    } else {
      data = admin
    }

    //
    excludeFields = [...Admin.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Admin)) {
      throw Error(`${name} must be an instance of the Admin class.`)
    }
  }
}
